import { lazy } from 'react';
import Loadable from 'ui-component/Loadable';
import PrivateRoute from './privateRoute';

const MainLayout = Loadable(lazy(() => import('../layout/MainLayout')));
const DashboardDefault = Loadable(lazy(() => import('views/dashboard/Default')));
const CreerBatch = Loadable(lazy(() => import('../views/dashboard/Batch/CreerBatch')));
const Users = Loadable(lazy(() => import('views/dashboard/Users')));
const UpgradeAccount = Loadable(lazy(() => import('views/dashboard/Sales/upgradeAccount')));
const Advance = Loadable(lazy(() => import('views/dashboard/Sales/advance')));
const CashDeposit = Loadable(lazy(() => import('views/dashboard/Sales/cashDeposit')));
const CashDeposit2 = Loadable(lazy(() => import('views/dashboard/Sales/cashDeposit2')));
const SalesList = Loadable(lazy(() => import('views/dashboard/Sales/SalesList')));
const Order = Loadable(lazy(() => import('views/dashboard/Order')));
const TransferCards = Loadable(lazy(() => import('views/dashboard/TransferCards')));
const TransferHistory = Loadable(lazy(() => import('views/dashboard/TransferHistory')));

const CompanyDeposit = Loadable(lazy(() => import('views/dashboard/companyDeposit')));
const CompanyTopupRequest = Loadable(lazy(() => import('views/dashboard/companyTopupRequest')));
const ZonesV3 = Loadable(lazy(() => import('views/dashboard/ZonesGeographiques/ZonesV3')));
const IncidentList = Loadable(lazy(() => import('views/dashboard/Incidents/IncidentList')));
const LitigationList = Loadable(lazy(() => import('views/dashboard/Incidents/LitigationList')));
const ComplianceBlock = Loadable(lazy(() => import('views/dashboard/Incidents/ComplianceBlock')));

const MainRoutes = {
  path: '/',
  element: <PrivateRoute />,
  children: [
    {
      path: '',
      element: <MainLayout />,
      children: [
        {
          path: 'dashboard/Default',
          element: <DashboardDefault />
        },
        {
          path: 'dashboard/Batch',
          element: <CreerBatch />
        },
        {
          path:'dashboard/Users',
          element:<Users/>
        },
        {
          path:'dashboard/UpgradeAccount',
          element:<UpgradeAccount />
        },
        {
          path:'dashboard/advance',
          element:<Advance/>
        },
        {
          path:'dashboard/CashDeposit',
          element:<CashDeposit/>
        },
        {
          path:'dashboard/CashDeposit2',
          element:<CashDeposit2/>
        },
        {
          path:'dashboard/salesList',
          element:<SalesList/>
        },
        {
          path: 'dashboard/Order',
          element: <Order />
        },
        {
          path: 'dashboard/TransferCards',
          element: <TransferCards />
        },
        {
          path: 'dashboard/TransferHistory',
          element: <TransferHistory />
        },

        {
          path: 'dashboard/companyDeposit',
          element: <CompanyDeposit />
        },
        {
          path: 'dashboard/companyTopupRequest',
          element: <CompanyTopupRequest />
        },
        {
          path: 'dashboard/Zones',
          element: <ZonesV3 />
        },
        {
          path: 'dashboard/incidentList',
          element: <IncidentList />
        },
        {
          path: 'dashboard/litigationList',
          element: <LitigationList />
        },
        {
          path: 'dashboard/complianceBlock',
          element: <ComplianceBlock />
        }
      ]
    }
  ]
};

export default MainRoutes;